/**
 * Created by quikr on 8/3/16.
 */
/*eslint-disable no-console*/
export const loadState = () => {
  try {
    const serializableState = localStorage.getItem('state');
    if (serializableState === null)
      return undefined;
    return JSON.parse(serializableState);
  }
  catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    console.log("saving state");


    const serializableState = JSON.stringify(state);
    localStorage.setItem('state', serializableState);
    if (!state.auth[0].loggedIn) {

      localStorage.removeItem('state');
    }

  } catch (err) {//ignore
    console.log("error in save state");
  }
};

export const refreshState = (auth) => {
  try {
    if (auth[0].loggedIn === false)
      localStorage.removeItem('state');
  }
  catch (err) {
    //
    console.log("error in refresh state");
  }
};




/** WEBPACK FOOTER **
 ** ./src/loadState.js
 **/